import React, { useEffect, useState } from 'react';
import {
    Box, Typography, Button, Modal, TextField,
    MenuItem, Select, InputLabel, FormControl,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, CircularProgress, Alert, IconButton, Tooltip
} from '@mui/material';
import Nlayout from './Nlayout';
import axios from 'axios';
import { MdPersonAddAlt1, MdDeleteForever } from 'react-icons/md';
import { IoCloseCircleOutline } from 'react-icons/io5';
import { FaSearch } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';
import './Rankings.css';

const API_BASE = 'https://backend.eldenguee.com/sorteo';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 460,
    maxWidth: '92vw',
    bgcolor: 'rgba(15, 18, 28, 0.95)',
    backdropFilter: 'blur(24px)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: '24px',
    boxShadow: '0 30px 80px rgba(0,0,0,0.5)',
    p: 4,
};

const confirmModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    maxWidth: '90vw',
    bgcolor: 'rgba(15, 18, 28, 0.95)',
    backdropFilter: 'blur(24px)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: '24px',
    boxShadow: '0 30px 80px rgba(0,0,0,0.5)',
    p: 4,
    textAlign: 'center',
};

export default function ListadoBlacklist({ isMobile }) {
    const [blacklist, setBlacklist] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingAction, setLoadingAction] = useState(false);
    const [modalAgregar, setModalAgregar] = useState(false);
    const [modalConfirmar, setModalConfirmar] = useState(false);
    const [usuarioSeleccionado, setUsuarioSeleccionado] = useState('');
    const [usuarioEliminar, setUsuarioEliminar] = useState(null);
    const [busqueda, setBusqueda] = useState('');
    const [busquedaListado, setBusquedaListado] = useState('');
    const [mensaje, setMensaje] = useState({ text: '', type: '' });

    const obtenerBlacklist = async () => {
        try {
            setLoading(true);
            const res = await axios.get(`${API_BASE}/blacklist`, {
                headers: {
                    "x-internal-api-key": process.env.REACT_APP_PANEL_API_KEY || process.env.REACT_APP_INTERNAL_API_KEY || 'ed_qatar_2022_messi_dengueclarasoluna_2026',
                    "x-api-key": process.env.REACT_APP_PANEL_API_KEY || process.env.REACT_APP_INTERNAL_API_KEY || 'ed_qatar_2022_messi_dengueclarasoluna_2026'
                }
            });
            setBlacklist(res.data?.recordset || res.data || []);
        } catch (error) {
            console.error('Error al obtener blacklist:', error);
            setMensaje({ text: 'Error al obtener la blacklist', type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const obtenerUsuarios = async () => {
        try {
            const res = await axios.get('https://backend.eldenguee.com/solicitudes/usuarios', {
                headers: {
                    "x-internal-api-key": process.env.REACT_APP_PANEL_API_KEY || process.env.REACT_APP_INTERNAL_API_KEY || 'ed_qatar_2022_messi_dengueclarasoluna_2026',
                    "x-api-key": process.env.REACT_APP_PANEL_API_KEY || process.env.REACT_APP_INTERNAL_API_KEY || 'ed_qatar_2022_messi_dengueclarasoluna_2026'
                }
            });
            setUsuarios(res.data || []);
        } catch (error) {
            console.error('Error al obtener usuarios:', error);
        }
    };

    useEffect(() => {
        obtenerBlacklist();
        obtenerUsuarios();
    }, []);

    const agregarUsuario = async () => {
        if (!usuarioSeleccionado) return;
        try {
            setLoadingAction(true);
            await axios.post(`${API_BASE}/blacklist/agregar`, { nombre: usuarioSeleccionado }, {
                headers: {
                    "x-internal-api-key": process.env.REACT_APP_PANEL_API_KEY || process.env.REACT_APP_INTERNAL_API_KEY || 'ed_qatar_2022_messi_dengueclarasoluna_2026',
                    "x-api-key": process.env.REACT_APP_PANEL_API_KEY || process.env.REACT_APP_INTERNAL_API_KEY || 'ed_qatar_2022_messi_dengueclarasoluna_2026'
                }
            });
            setMensaje({ text: `${usuarioSeleccionado} agregado a la blacklist`, type: 'success' });
            setUsuarioSeleccionado('');
            setBusqueda('');
            setModalAgregar(false);
            await obtenerBlacklist();
        } catch (error) {
            console.error('Error al agregar a blacklist:', error);
            setMensaje({ text: 'Error al agregar usuario', type: 'error' });
        } finally {
            setLoadingAction(false);
        }
    };

    const eliminarUsuario = async () => {
        if (!usuarioEliminar) return;
        try {
            setLoadingAction(true);
            await axios.delete(`${API_BASE}/blacklist/${usuarioEliminar.id}`, {
                headers: {
                    "x-internal-api-key": process.env.REACT_APP_PANEL_API_KEY || process.env.REACT_APP_INTERNAL_API_KEY || 'ed_qatar_2022_messi_dengueclarasoluna_2026',
                    "x-api-key": process.env.REACT_APP_PANEL_API_KEY || process.env.REACT_APP_INTERNAL_API_KEY || 'ed_qatar_2022_messi_dengueclarasoluna_2026'
                }
            });
            setMensaje({ text: `${usuarioEliminar.nombre} eliminado de la blacklist`, type: 'success' });
            setUsuarioEliminar(null);
            setModalConfirmar(false);
            await obtenerBlacklist();
        } catch (error) {
            console.error('Error al eliminar de blacklist:', error);
            setMensaje({ text: 'Error al eliminar usuario', type: 'error' });
        } finally {
            setLoadingAction(false);
        }
    };

    const [activeTab, setActiveTab] = useState('sorteo'); // 'sorteo' | 'publica'

    const usuariosFiltrados = usuarios.filter((u) =>
        u.nombre?.toLowerCase().includes(busqueda.toLowerCase())
    );

    const blacklistFiltrada = blacklist.filter((u) => {
        const matchesSearch = u.nombre?.toLowerCase().includes(busquedaListado.toLowerCase());
        const tieneMotivo = Boolean(u.motivo && String(u.motivo).trim() !== '');
        if (activeTab === 'sorteo') {
            return matchesSearch && !tieneMotivo;
        } else {
            return matchesSearch && tieneMotivo;
        }
    });

    // Auto-clear messages
    useEffect(() => {
        if (mensaje.text) {
            const timer = setTimeout(() => setMensaje({ text: '', type: '' }), 4000);
            return () => clearTimeout(timer);
        }
    }, [mensaje]);

    return (
        <Nlayout>
            <div className="rankings-container">
                <div className="rankings-content">
                    {/* Header */}
                    <div className="admin-rankings-title-row">
                        <div>
                            <h1 className="rankings-title">Listado Blacklist</h1>
                        </div>
                        <Button
                            variant="contained"
                            startIcon={<MdPersonAddAlt1 size={20} />}
                            onClick={() => setModalAgregar(true)}
                            sx={{
                                height: 46,
                                borderRadius: '12px',
                                fontWeight: 700,
                                fontSize: 14,
                                textTransform: 'none',
                                color: '#111',
                                fontFamily: 'Outfit',
                                background: 'linear-gradient(135deg, #53FC18, #31d158)',
                                boxShadow: '0 10px 30px rgba(83,252,24,0.25)',
                                transition: '.25s',
                                px: 2.5,
                                whiteSpace: 'nowrap',
                                '&:hover': {
                                    background: 'linear-gradient(135deg, #63ff32, #53FC18)',
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 18px 40px rgba(83,252,24,0.35)',
                                },
                            }}
                        >
                            Agregar Usuario
                        </Button>
                    </div>

                    {/* Alert message */}
                    <AnimatePresence>
                        {mensaje.text && (
                            <motion.div
                                initial={{ opacity: 0, y: -20 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -20 }}
                                transition={{ duration: 0.3 }}
                            >
                                <Alert
                                    severity={mensaje.type}
                                    onClose={() => setMensaje({ text: '', type: '' })}
                                    sx={{
                                        mb: 3,
                                        borderRadius: '14px',
                                        fontFamily: 'Outfit',
                                        bgcolor: mensaje.type === 'success' ? 'rgba(83,252,24,0.08)' : 'rgba(255,82,82,0.08)',
                                        color: mensaje.type === 'success' ? '#53FC18' : '#ff5252',
                                        border: `1px solid ${mensaje.type === 'success' ? 'rgba(83,252,24,0.2)' : 'rgba(255,82,82,0.2)'}`,
                                        '& .MuiAlert-icon': {
                                            color: mensaje.type === 'success' ? '#53FC18' : '#ff5252',
                                        },
                                    }}
                                >
                                    {mensaje.text}
                                </Alert>
                            </motion.div>
                        )}
                    </AnimatePresence>

                    {/* Tab Navigation */}
                    <div style={{ display: 'flex', gap: '12px', marginBottom: '20px' }}>
                        <button
                            onClick={() => setActiveTab('sorteo')}
                            style={{
                                padding: '10px 20px',
                                borderRadius: '12px',
                                border: '1px solid',
                                borderColor: activeTab === 'sorteo' ? '#53FC18' : 'rgba(255,255,255,0.1)',
                                backgroundColor: activeTab === 'sorteo' ? 'rgba(83,252,24,0.15)' : 'rgba(255,255,255,0.03)',
                                color: activeTab === 'sorteo' ? '#53FC18' : 'rgba(255,255,255,0.6)',
                                fontWeight: 700,
                                fontFamily: 'Outfit',
                                fontSize: '0.95rem',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                            }}
                        >
                            Blacklist Sorteo
                        </button>
                        <button
                            onClick={() => setActiveTab('publica')}
                            style={{
                                padding: '10px 20px',
                                borderRadius: '12px',
                                border: '1px solid',
                                borderColor: activeTab === 'publica' ? '#53FC18' : 'rgba(255,255,255,0.1)',
                                backgroundColor: activeTab === 'publica' ? 'rgba(83,252,24,0.15)' : 'rgba(255,255,255,0.03)',
                                color: activeTab === 'publica' ? '#53FC18' : 'rgba(255,255,255,0.6)',
                                fontWeight: 700,
                                fontFamily: 'Outfit',
                                fontSize: '0.95rem',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                            }}
                        >
                            Blacklist Pública
                        </button>
                    </div>

                    {/* Search bar */}
                    <div className="rankings-controls" style={{ marginBottom: '30px' }}>
                        <div style={{ position: 'relative', flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                            <input
                                type="text"
                                className="rankings-search-input"
                                placeholder={`Buscar usuario en ${activeTab === 'sorteo' ? 'blacklist sorteo' : 'blacklist pública'}...`}
                                value={busquedaListado}
                                onChange={(e) => setBusquedaListado(e.target.value)}
                                style={{ paddingLeft: '45px' }}
                            />
                            <FaSearch style={{ position: 'absolute', left: '18px', color: 'rgba(255,255,255,0.3)' }} />
                        </div>
                    </div>

                    {/* Content */}
                    {loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '60px 0' }}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                border: '4px solid rgba(255, 255, 255, 0.1)',
                                borderTop: '4px solid #53FC18',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite'
                            }} />
                            <style>{`
                                @keyframes spin {
                                    0% { transform: rotate(0deg); }
                                    100% { transform: rotate(360deg); }
                                }
                            `}</style>
                        </div>
                    ) : blacklistFiltrada.length === 0 ? (
                        <div className="rankings-rules-card" style={{ textAlign: 'center', padding: '50px 20px' }}>
                            <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '1.2rem', margin: 0 }}>
                                {busquedaListado
                                    ? 'No se encontraron usuarios que coincidan con la búsqueda.'
                                    : `No hay usuarios en ${activeTab === 'sorteo' ? 'blacklist sorteo' : 'blacklist pública'}.`
                                }
                            </p>
                        </div>
                    ) : (
                        <div className="rankings-table-container">
                            <table className="rankings-table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Usuario</th>
                                        {activeTab === 'publica' && <th>Motivo</th>}
                                        <th style={{ textAlign: 'right' }}>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {blacklistFiltrada.map((usuario, index) => (
                                        <tr key={usuario.id || index}>
                                            <td>
                                                <span style={{ fontWeight: 700, color: 'rgba(255,255,255,0.5)' }}>
                                                    {index + 1}
                                                </span>
                                            </td>
                                            <td>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                    <div style={{
                                                        width: 34,
                                                        height: 34,
                                                        borderRadius: '10px',
                                                        background: 'linear-gradient(135deg, rgba(83,252,24,0.15), rgba(83,252,24,0.05))',
                                                        border: '1px solid rgba(83,252,24,0.2)',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        color: '#53FC18',
                                                        fontWeight: 700,
                                                        fontSize: 13,
                                                        fontFamily: 'Outfit',
                                                        flexShrink: 0,
                                                    }}>
                                                        {(usuario.nombre || '?')[0]?.toUpperCase()}
                                                    </div>
                                                    <span style={{ fontWeight: 600 }}>{usuario.nombre}</span>
                                                </div>
                                            </td>
                                            {activeTab === 'publica' && (
                                                <td>
                                                    <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.9rem' }}>
                                                        {usuario.motivo || '-'}
                                                    </span>
                                                </td>
                                            )}
                                            <td style={{ textAlign: 'right' }}>
                                                <button
                                                    onClick={() => {
                                                        setUsuarioEliminar(usuario);
                                                        setModalConfirmar(true);
                                                    }}
                                                    style={{
                                                        background: 'rgba(255,82,82,0.1)',
                                                        color: '#ff5252',
                                                        border: '1px solid rgba(255,82,82,0.3)',
                                                        borderRadius: '8px',
                                                        padding: '6px 14px',
                                                        fontSize: '0.85rem',
                                                        fontWeight: 600,
                                                        cursor: 'pointer',
                                                        transition: 'all 0.2s ease',
                                                        fontFamily: 'Outfit',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.background = '#ff5252';
                                                        e.target.style.color = '#000';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.background = 'rgba(255,82,82,0.1)';
                                                        e.target.style.color = '#ff5252';
                                                    }}
                                                >
                                                    <MdDeleteForever size={16} />
                                                    Eliminar
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {/* Total count */}
                    {!loading && blacklistFiltrada.length > 0 && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-20px', marginBottom: '20px' }}>
                            <span style={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.85rem', fontFamily: 'Outfit' }}>
                                {busquedaListado
                                    ? `${blacklistFiltrada.length} de ${blacklist.length} usuario${blacklist.length !== 1 ? 's' : ''}`
                                    : `Total: ${blacklist.length} usuario${blacklist.length !== 1 ? 's' : ''}`
                                }
                            </span>
                        </div>
                    )}

                    {/* ===== MODAL AGREGAR USUARIO ===== */}
                    <Modal
                        open={modalAgregar}
                        onClose={() => {
                            setModalAgregar(false);
                            setUsuarioSeleccionado('');
                            setBusqueda('');
                        }}
                    >
                        <Box sx={modalStyle}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                                <Typography
                                    sx={{
                                        color: '#fff',
                                        fontWeight: 700,
                                        fontSize: 22,
                                        fontFamily: 'Outfit',
                                    }}
                                >
                                    Agregar a Blacklist
                                </Typography>
                                <IconButton
                                    onClick={() => {
                                        setModalAgregar(false);
                                        setUsuarioSeleccionado('');
                                        setBusqueda('');
                                    }}
                                    sx={{ color: '#9CA3AF' }}
                                >
                                    <IoCloseCircleOutline size={26} />
                                </IconButton>
                            </Box>

                            <FormControl fullWidth variant="outlined" sx={{ mb: 3 }}>
                                <InputLabel sx={{ color: '#9CA3AF', fontFamily: 'Outfit' }}>
                                    Seleccionar Usuario
                                </InputLabel>
                                <Select
                                    value={usuarioSeleccionado}
                                    onChange={(e) => setUsuarioSeleccionado(e.target.value)}
                                    label="Seleccionar Usuario"
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 280,
                                                background: 'rgba(20,23,35,0.98)',
                                                backdropFilter: 'blur(20px)',
                                                borderRadius: '14px',
                                                border: '1px solid rgba(255,255,255,0.08)',
                                            },
                                        },
                                    }}
                                    sx={{
                                        color: '#fff',
                                        fontFamily: 'Outfit',
                                        borderRadius: '14px',
                                        '.MuiOutlinedInput-notchedOutline': {
                                            borderColor: 'rgba(255,255,255,0.12)',
                                            borderRadius: '14px',
                                        },
                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                            borderColor: 'rgba(83,252,24,0.3)',
                                        },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#53FC18',
                                        },
                                        '.MuiSvgIcon-root': {
                                            color: '#9CA3AF',
                                        },
                                    }}
                                >
                                    {/* Search field inside select */}
                                    <MenuItem disableRipple disableTouchRipple sx={{ '&:hover': { background: 'transparent' } }}>
                                        <TextField
                                            size="small"
                                            placeholder="Buscar usuario..."
                                            value={busqueda}
                                            onChange={(e) => setBusqueda(e.target.value)}
                                            onClick={(e) => e.stopPropagation()}
                                            onKeyDown={(e) => e.stopPropagation()}
                                            fullWidth
                                            sx={{
                                                '& .MuiInputBase-input': {
                                                    color: '#fff',
                                                    fontFamily: 'Outfit',
                                                },
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '10px',
                                                    '& fieldset': {
                                                        borderColor: 'rgba(255,255,255,0.12)',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: 'rgba(83,252,24,0.3)',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: '#53FC18',
                                                    },
                                                },
                                                '& .MuiInputBase-input::placeholder': {
                                                    color: '#6B7280',
                                                    opacity: 1,
                                                },
                                            }}
                                        />
                                    </MenuItem>

                                    {usuariosFiltrados.map((u, idx) => (
                                        <MenuItem
                                            key={idx}
                                            value={u.nombre}
                                            sx={{
                                                color: '#fff',
                                                fontFamily: 'Outfit',
                                                borderRadius: '8px',
                                                mx: 1,
                                                '&:hover': {
                                                    background: 'rgba(83,252,24,0.08)',
                                                },
                                                '&.Mui-selected': {
                                                    background: 'rgba(83,252,24,0.12)',
                                                    '&:hover': {
                                                        background: 'rgba(83,252,24,0.16)',
                                                    },
                                                },
                                            }}
                                        >
                                            {u.nombre}
                                        </MenuItem>
                                    ))}

                                    {usuariosFiltrados.length === 0 && (
                                        <MenuItem disabled sx={{ color: '#6B7280', fontFamily: 'Outfit' }}>
                                            No se encontraron resultados
                                        </MenuItem>
                                    )}
                                </Select>
                            </FormControl>

                            <Button
                                fullWidth
                                variant="contained"
                                disabled={!usuarioSeleccionado || loadingAction}
                                startIcon={loadingAction ? <CircularProgress size={18} sx={{ color: '#111' }} /> : <MdPersonAddAlt1 size={20} />}
                                onClick={agregarUsuario}
                                sx={{
                                    height: 52,
                                    borderRadius: '14px',
                                    fontWeight: 700,
                                    fontSize: 15,
                                    textTransform: 'none',
                                    fontFamily: 'Outfit',
                                    color: '#111',
                                    background: 'linear-gradient(135deg, #53FC18, #31d158)',
                                    boxShadow: '0 10px 30px rgba(83,252,24,0.25)',
                                    transition: '.25s',
                                    '&:hover': {
                                        background: 'linear-gradient(135deg, #63ff32, #53FC18)',
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 18px 40px rgba(83,252,24,0.35)',
                                    },
                                    '&.Mui-disabled': {
                                        background: '#2b2b2b',
                                        color: '#666',
                                    },
                                }}
                            >
                                Agregar a Blacklist
                            </Button>
                        </Box>
                    </Modal>

                    {/* ===== MODAL CONFIRMAR ELIMINACIÓN ===== */}
                    <Modal
                        open={modalConfirmar}
                        onClose={() => {
                            setModalConfirmar(false);
                            setUsuarioEliminar(null);
                        }}
                    >
                        <Box sx={confirmModalStyle}>
                            <Box
                                sx={{
                                    width: 64,
                                    height: 64,
                                    borderRadius: '20px',
                                    background: 'rgba(255,82,82,0.1)',
                                    border: '1px solid rgba(255,82,82,0.2)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mx: 'auto',
                                    mb: 3,
                                }}
                            >
                                <MdDeleteForever size={32} color="#ff5252" />
                            </Box>

                            <Typography
                                sx={{
                                    color: '#fff',
                                    fontWeight: 700,
                                    fontSize: 20,
                                    fontFamily: 'Outfit',
                                    mb: 1.5,
                                }}
                            >
                                ¿Eliminar de la Blacklist?
                            </Typography>

                            <Typography
                                sx={{
                                    color: '#9CA3AF',
                                    fontSize: 15,
                                    fontFamily: 'Outfit',
                                    mb: 4,
                                    lineHeight: 1.6,
                                }}
                            >
                                Estás por eliminar a{' '}
                                <span style={{ color: '#53FC18', fontWeight: 700 }}>
                                    {usuarioEliminar?.nombre}
                                </span>{' '}
                                de la blacklist. Esta acción no se puede deshacer.
                            </Typography>

                            <Box sx={{ display: 'flex', gap: 2 }}>
                                <Button
                                    fullWidth
                                    variant="outlined"
                                    onClick={() => {
                                        setModalConfirmar(false);
                                        setUsuarioEliminar(null);
                                    }}
                                    sx={{
                                        height: 48,
                                        borderRadius: '14px',
                                        fontWeight: 600,
                                        textTransform: 'none',
                                        fontFamily: 'Outfit',
                                        color: '#9CA3AF',
                                        borderColor: 'rgba(255,255,255,0.12)',
                                        '&:hover': {
                                            borderColor: 'rgba(255,255,255,0.25)',
                                            background: 'rgba(255,255,255,0.04)',
                                        },
                                    }}
                                >
                                    Cancelar
                                </Button>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    disabled={loadingAction}
                                    startIcon={loadingAction ? <CircularProgress size={18} sx={{ color: '#fff' }} /> : null}
                                    onClick={eliminarUsuario}
                                    sx={{
                                        height: 48,
                                        borderRadius: '14px',
                                        fontWeight: 700,
                                        textTransform: 'none',
                                        fontFamily: 'Outfit',
                                        color: '#fff',
                                        background: 'linear-gradient(135deg, #ff5252, #d32f2f)',
                                        boxShadow: '0 10px 25px rgba(255,82,82,0.25)',
                                        transition: '.25s',
                                        '&:hover': {
                                            background: 'linear-gradient(135deg, #ff6b6b, #ff5252)',
                                            transform: 'translateY(-2px)',
                                            boxShadow: '0 15px 35px rgba(255,82,82,0.35)',
                                        },
                                        '&.Mui-disabled': {
                                            background: '#2b2b2b',
                                            color: '#666',
                                        },
                                    }}
                                >
                                    Eliminar
                                </Button>
                            </Box>
                        </Box>
                    </Modal>
                </div>
            </div>
        </Nlayout>
    );
}
